(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.Calendar",
                    {
                        url: "",
                        component: "calendarNew",
                        redirectTo: "Home.Tools.MarketingTrackerNew.Events.Calendar.CalendarView"
                    });
        }
    ]);

    app
        .component("calendarNew",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/Calendar/calendar-new-template.html",
                controller: calendarNewController,
                bindings: {
                    user: "<",
                    onBehalfOfUser: "<"
                }
            });

    calendarNewController.$inject = [];
    function calendarNewController() {
        const $ctrl = this;
    }

})(window.app, window.angular); //jshint ignore:line